import React, { useEffect, useState } from 'react';
import { ShowAt } from 'consts/breakpoints';
import ArrowIcon from 'assets/svg/developer/arrow-down-thiсk.svg';
import MobileArrowIcon from 'assets/svg/developer/arrow-down.svg';
import * as Styled from './styled';
import { ProjectCount } from '../styled';


interface ExpandableSectionProps {
  title: string;
  expanded: boolean;
  count: number;
  isFirst?: boolean;
}

const ExpandableSection: React.FC<ExpandableSectionProps> = (props) => {
  const { title, children, expanded, isFirst, count } = props;
  const [ isOpen, setIsOpen ] = useState(false);
  const toggleIsOpen = () => setIsOpen(!isOpen);
  useEffect(() => {
    setIsOpen(expanded);
  }, [ expanded ]);

  return (
    <Styled.Wrapper>
      <Styled.Header weight="bold" isOpen={isOpen} onClick={toggleIsOpen} isFirst={isFirst}>
        <Styled.ArrowIconWrapper>
          <ShowAt at={1}>
            {(isMobile) => isMobile ? <MobileArrowIcon /> : <ArrowIcon />}
          </ShowAt>
        </Styled.ArrowIconWrapper>
        <div>{title} <ProjectCount>· {count}</ProjectCount></div>
      </Styled.Header>
      {isOpen ? (
        <Styled.Content>
          {children}
        </Styled.Content>
      ) : null}
    </Styled.Wrapper>
  );
};

export default ExpandableSection;
